import axios from '@axios'
import { storePagination, sorting } from '@/mixins'

const getInitialState = () => ({
  ...storePagination.state(),
  paging: {
    ...storePagination.state().paging,
    pageSize: 50,
  },
  stockCountingRules: [],
  ruleForm: {
    id: null,
    groupId: null,
    brandIds: [],
    daysOfWeek: [],
    minCountings: 1,
    active: true,
    description: null,
  },
  filters: {
    groupId: null,
    brandId: null,
    dayOfWeek: null,
    activeOnly: null,
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {},

  mutations: {
    ...storePagination.mutations,

    SET_STOCK_COUNTING_RULES(state, rules) {
      state.stockCountingRules = rules
    },
    SET_RULE_FORM(state, rule) {
      state.ruleForm = { ...rule }
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_FILTERS(state) {
      const { filters } = getInitialState()
      state.filters = filters
    },
    CLEAN_RULE_FORM(state) {
      const { ruleForm } = getInitialState()
      state.ruleForm = { ...ruleForm }
    },
    CLEAN_STATE(state) {
      const initialState = getInitialState()
      Object.keys(initialState).forEach(key => {
        state[key] = initialState[key]
      })
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchStockCountingRules({ commit, state }) {
      const { data } = await axios.get('/api/stock-counting-rules', {
        params: {
          groupId: state.filters.groupId,
          brandId: state.filters.brandId,
          dayOfWeek: state.filters.dayOfWeek,
          activeOnly: state.filters.activeOnly,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_STOCK_COUNTING_RULES', data.results || [])
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })
    },

    async saveRule({ state }) {
      const payload = {
        // O combo trabalha com ids como string na UI; o backend espera int.
        groupId:
          state.ruleForm.groupId != null && state.ruleForm.groupId !== ''
            ? Number(state.ruleForm.groupId)
            : null,
        brandIds: (state.ruleForm.brandIds || []).map(Number),
        daysOfWeek: state.ruleForm.daysOfWeek || [],
        minCountings: state.ruleForm.minCountings,
        active: state.ruleForm.active,
        description: state.ruleForm.description,
      }

      if (state.ruleForm.id) {
        const { data } = await axios.put(`/api/stock-counting-rules/${state.ruleForm.id}`, payload)
        return data
      }
      const { data } = await axios.post('/api/stock-counting-rules', payload)
      return data
    },

    async deleteRule(_, id) {
      await axios.delete(`/api/stock-counting-rules/${id}`)
    },

    setRuleForm({ commit }, rule) {
      commit('SET_RULE_FORM', rule)
    },

    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('CLEAN_FILTERS')
    },

    cleanRuleForm({ commit }) {
      commit('CLEAN_RULE_FORM')
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
